import React from 'react';
import { observer } from 'mobx-react';
import { View } from '../../core/components/Index';
import useAsyncEffect from 'use-async-effect';
import { useNavigate } from 'react-router-dom';

const HomeView: React.FC = observer(() => {
  let navigate = useNavigate();
  useAsyncEffect(async () => {
    const location = window.location.host.toLowerCase();
    if (location.includes('localhost')) {
      navigate('/members/report-death')
    } else {
      window.location.href = 'https://scers.gov';
    }
  }, []);

  return (
    <>
      <View id="HomeView" showMenuBar={false} style={{ minHeight: '100%' }}>
        <div id="banner">
          {/* <BannerView /> */}
        </div>
      </View>
    </>
  );
});

export default HomeView;
